import { Vue } from 'vue-property-decorator';
import DefaultLayout from './default-layout/default-layout.vue';
import UnauthorizedLayout from './unauthorized-layout/unauthorized-layout.vue';

Vue.component('default-layout', DefaultLayout);
Vue.component('unauthorized-layout', UnauthorizedLayout);
